// app/javascript/contributions.js
import flatpickr from "flatpickr";

export function initContributions() {
  const form = document.getElementById("contributionForm");
  if (!form) return; // ✅ Only run if contributionForm is present

  // ✅ Initialize Flatpickr on the date field
  flatpickr("#contribution_date", {
    dateFormat: "Y-m-d",
    allowInput: true, // lets users type manually
    altInput: true,   // shows a prettier formatted date
    altFormat: "F j, Y"
  });


  // 1. Intercept offcanvas open events to hydrate field contents
  const offcanvasElement = document.getElementById("dokContributionFormModal");
  if (offcanvasElement) {
    offcanvasElement.addEventListener("show.bs.offcanvas", function (event) {
      const button = event.relatedTarget;
      if (!button) return;

      const action = button.getAttribute("data-action");

      if (action === "edit") {
        form.dataset.contributionId = button.getAttribute("data-contribution-id");

        // Pre-fill fields
        document.getElementById("contribution_date").value = button.getAttribute("data-contribution-date") || "";
        document.getElementById("contribution_status").value = button.getAttribute("data-contribution-status") || "pending";

        // TODO: hydrate line items if you pass them as data attributes
      } else {
        form.dataset.contributionId = "";
        form.reset();
        document.getElementById("lineItemsContainer").innerHTML = ""; // clear line items
      }
    });
  }

  // 2. Add new line item dynamically
  const addLineItemBtn = document.getElementById("addLineItemBtn");
  if (addLineItemBtn) {
    addLineItemBtn.onclick = function () {
      const container = document.getElementById("lineItemsContainer");
      const row = document.createElement("div");
      row.className = "line-item row mb-2";

      row.innerHTML = `
        <div class="col-xl-6">
          <select class="form-select contribution-type">
            ${window.contributionTypes.map(ct => `<option value="${ct}">${ct}</option>`).join("")}
          </select>
        </div>
        <div class="col-xl-6">
          <input type="number" class="form-control contribution-amount" placeholder="Amount" min="1">
        </div>
      `;

      container.appendChild(row);
    };
  }

  // 3. Process Asynchronous Form Submission
  const saveBtn = document.getElementById("saveContributionBtn");
  if (saveBtn) {
    saveBtn.onclick = function () {
      const contributionId = form.dataset.contributionId;

      const url = contributionId ? `/contributions/${contributionId}` : "/contributions";
      const method = contributionId ? "PATCH" : "POST";

      // Build line items payload
      const lineItems = [];
      document.querySelectorAll("#lineItemsContainer .line-item").forEach(row => {
        const type = row.querySelector(".contribution-type").value;
        const amount = row.querySelector(".contribution-amount").value;
        if (type && amount) {
          lineItems.push({ contribution_type: type, amount: amount });
        }
      });

      const payload = {
        exact_payment_date: document.getElementById("contribution_date").value,
        status: document.getElementById("contribution_status").value,
        line_items: lineItems
      };

      fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
        },
        body: JSON.stringify({ contribution: payload })
      })
        .then(response => response.json())
        .then(data => {
          if (data.success || data.id) {
            window.location.reload(); // reload to update table
          } else {
            if (data.errors && Array.isArray(data.errors)) {
              alert(data.errors.join(", "));
            } else {
              alert(data.error || "An error occurred during contribution mutation");
            }
          }
        })
        .catch(error => {
          console.error("Communication failure:", error);
          alert("Network error processing contribution entry");
        });
    };
  }
}

// Global initializer
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initContributions);
} else {
  initContributions();
}
